import type { ReactNode } from 'react';
import { DropDownBox, DropDownBoxLayoutStyle } from './DropDownBox';

interface YearDropDownProps {
    id: string;
    value: number | undefined;
    label: string;
    helperText?: string;
    required?: boolean;
    placeholder?: string;
    width?: string;
    yearStart: number;
    readOnly?: boolean;
    onChange: (value: string) => void;
    componentSpacing?: string;
    showInfoIcon?: boolean;
    infoText?: ReactNode;
    /** Label above the dropdown (Vertical, default) or beside it (Horizontal). */
    layoutStyle?: DropDownBoxLayoutStyle;
    /** Width of the label column when layoutStyle is Horizontal. Defaults to 120px. */
    labelWidth?: string;
    /** Height of the dropdown box. Omit to keep DropDownBox's default (54px). */
    height?: string;
}

export const YearDropDown: React.FC<YearDropDownProps> = ({
    id,
    value,
    label,
    helperText,
    required = false,
    placeholder,
    width,
    yearStart,
    readOnly = false,
    onChange,
    showInfoIcon = false,
    infoText,
    layoutStyle,
    labelWidth,
    height,
}) => {
    const yearValues = (): number[] => {
        const start = yearStart;
        let yearEnd = new Date().getFullYear();

        const years = [];

        while (start < yearEnd + 1) {
            years.push(yearEnd);
            yearEnd--;
        }
        return years;
    };

    return (
        <DropDownBox
            id={id}
            value={value}
            onChange={onChange}
            label={label}
            helperText={helperText}
            required={required}
            dataSource={yearValues()}
            placeholder={placeholder}
            width={width}
            readOnly={readOnly}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
            layoutStyle={layoutStyle}
            labelWidth={labelWidth}
            height={height}
        />
    );
};
